import addDocumentIsLoading from './addDocumentIsLoading';
import addNoteIsLoading from './addNoteIsLoading';
import archiveThreadMessageIsLoading from './archiveThreadMessageIsLoading';
import createThreadIsLoading from './createThreadIsLoading';
import createThreadMessageIsLoading from './createThreadMessageIsLoading';
import editIsLoading from './editIsLoading';
import getAllCount from './getAllCount';
import getAllEmptyMsg from './getAllEmptyMsg';
import getAllErrorMsg from './getAllErrorMsg';
import getAllFilters from './getAllFilters';
import getAllIsLoading from './getAllIsLoading';
import getAllList from './getAllList';
import getAllPagination from './getAllPagination';
import getAllThreadsEmptyMessage from './getAllThreadsEmptyMessage';
import getAllThreadsErrorMessage from './getAllThreadsErrorMessage';
import getAllThreadsIsLoading from './getAllThreadsIsLoading';
import getAllThreadsList from './getAllThreadsList';
import getAvailableDocuments from './getAvailableDocuments';
import getDetailsClaimInfo from './getDetailsClaimInfo';
import getDetailsIsLoading from './getDetailsIsLoading';
import getDetailsTimeline from './getDetailsTimeline';
import getDetailsTimelineActiveActionIndex from './getDetailsTimelineActionIndex';
import getDetailsValues from './getDetailsValues';
import getDocuments from './getDocuments';
import getDocumentsIsLoading from './getDocumentsIsLoading';
import getSearchedInterventionEmptyMsg from './getSearchedInterventionEmptyMsg';
import getSearchedInterventionErrorMsg from './getSearchedInterventionErrorMsg';
import getSearchedInterventionIsLoading from './getSearchedInterventionIsLoading';
import getSearchedInterventionList from './getSearchedInterventionList';
import getStatusDateChangedIsLoading from './getStatusDateChangedIsLoading';
import getStatusDateChangedValues from './getStatusDateChangedValues';
import markThreadMessageAsOpenIsLoading from './markThreadMessageAsOpenIsLoading';
import removeWorkerIsLoading from './removeWorkerIsLoading';
import updateNoteIsLoading from './updateNoteIsLoading';

const interventionSelectors = {
  addDocumentIsLoading,
  addNoteIsLoading,
  archiveThreadMessageIsLoading,
  createThreadMessageIsLoading,
  createThreadIsLoading,
  editIsLoading,
  getAllFilters,
  getAllCount,
  getAvailableDocuments,
  getDocuments,
  getAllEmptyMsg,
  getAllErrorMsg,
  getAllList,
  getAllIsLoading,
  getAllPagination,
  getDetailsIsLoading,
  getDetailsTimeline,
  getDetailsTimelineActiveActionIndex,
  getDetailsValues,
  getDetailsClaimInfo,
  getSearchedInterventionIsLoading,
  getSearchedInterventionErrorMsg,
  getSearchedInterventionEmptyMsg,
  getDocumentsIsLoading,
  getSearchedInterventionList,
  getStatusDateChangedIsLoading,
  getStatusDateChangedValues,
  getAllThreadsEmptyMessage,
  getAllThreadsErrorMessage,
  getAllThreadsIsLoading,
  getAllThreadsList,
  markThreadMessageAsOpenIsLoading,
  removeWorkerIsLoading,
  updateNoteIsLoading,
};

export default interventionSelectors;
